function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import request from '@/utils/request';

/**
 * 查询福卡包列表
 */
export function listApi(params) {
  return request({
    url: "/admin/card/package/list",
    method: 'GET',
    params: params
  });
}

/**
 * 获取福卡包详情
 */
export function getCardPackageDetail(id) {
  return request({
    url: "/admin/card/package/detail",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 创建福卡包
 */
export function createApi(data) {
  return request({
    url: "/admin/card/package/save",
    method: 'POST',
    data: data
  });
}

/**
 * 编辑福卡包
 */
export function updateApi(data) {
  return request({
    url: "/admin/card/package/update",
    method: 'POST',
    data: data
  });
}

/**
 * 删除福卡包
 */
export function deleteApi(id) {
  return request({
    url: "/admin/card/package/delete",
    method: 'POST',
    params: {
      id: id
    }
  });
}

/**
 * 获取福卡列表
 */
export function getCardsApi() {
  return request({
    url: "/admin/card/package/valid-cards",
    method: 'GET'
  });
}

/**
 * 检查卡包是否可删除
 */
export function checkCanDeleteApi(id) {
  return request({
    url: "/admin/card/package/check-delete",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取兑换页面配置列表
 */
export function getExchangePageConfigsApi(params) {
  return request({
    url: "/admin/company-design/list",
    method: 'GET',
    params: _objectSpread({
      type: 4,
      page: (params === null || params === void 0 ? void 0 : params.page) || 1,
      limit: (params === null || params === void 0 ? void 0 : params.limit) || 20
    }, params)
  });
}